import { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from '../../../layouts/dashboard';

const PageArticle = lazy(() => import('./views/article'));

const Article = () => {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<PageArticle />} />
      </Routes>
    </Layout>
  );
};

export default Article;
